import React, { useEffect, useState } from 'react';

const STORAGE_KEY = 'cookie_consent_v1';

function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      setVisible(stored !== 'accepted' && stored !== 'rejected');
    } catch (_) {
      setVisible(true);
    }
  }, []);

  const handleChoice = (choice) => {
    try {
      localStorage.setItem(STORAGE_KEY, choice);
    } catch (_) {}
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 inset-x-0 z-[1000]">
      <div className="mx-auto w-full bg-white/95 backdrop-blur border-t border-gray-200 shadow-[0_-4px_24px_rgba(0,0,0,0.08)]">
        <div className="max-w-7xl mx-auto px-6 py-4 flex flex-col sm:flex-row sm:items-center gap-4">
          <p className="text-sm text-gray-700 leading-relaxed">
            We use cookies to enhance your experience, analyze usage, and improve our services. 
            See our <a className="underline text-[#0055FF]" href="/privacy">Privacy Policy</a> for more.
          </p>
          <div className="flex items-center gap-3 ml-auto">
            <button
              type="button"
              onClick={() => handleChoice('rejected')}
              className="px-4 py-2 rounded-full text-sm border border-gray-300 text-gray-800 bg-white hover:bg-gray-50"
            >
              Decline
            </button>
            <button
              type="button"
              onClick={() => handleChoice('accepted')}
              className="px-5 py-2 rounded-full text-sm text-white bg-[#171717] hover:bg-black"
            >
              Accept
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CookieConsent;


